<template>
  <DSelect
    :items="itemsFiltered"
    :show="show"
    :itemsSelected="itemsSelected"
    :placeholder="placeholder"
    :isDeleteAllAnOption="false"
    @update="update"
    @close="$emit('close')">
    <h4 slot="noMatch">En person må have max seks kompetencer</h4>
  </DSelect>
</template>
<script>
import DSelect from '../../DSelect/DSelectCals'

export default {
  components: {DSelect},
  props: {
    items: {
      default: () => [],
      type: Array
    },
    itemsSelected: {
      default: () => [],
      type: Array
    },
    placeholder: {
      type: String,
      default: 'Søg og vælg kompetence'
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    itemsFiltered () {
      if (this.itemsSelected.length > 5) {
        return []
      }
      return this.items.filter(item => this.itemsSelected.findIndex(itemSelected => itemSelected.subject_code === item.subject_code) < 0)
    }
  },
  methods: {
    update (val) {
      this.$emit('update', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// KompetenceIndberetningDSelect.vue?64d1df24